export const SOURCE_MAPPINGS = {
    APIv2: 'API Integration',
    MANUAL: 'Manual Order Entry',
    CSV: 'CSV Upload',
    'CSV UPLOAD': 'CSV Upload',
    'JSON UPLOAD': 'JSON Upload',
    CUSTOMER: 'Customer Shipment',
};
